// extracted by mini-css-extract-plugin
module.exports = {"kidsAccountNavWrapper":"BG","hidden":"BH","menuBackground":"BI","avatar":"BJ","header":"BK","accountNavAvatar":"BL","buttonPlaceholder":"BM","accountLinks":"BN","accountLink":"BO"};